import { useState } from "react";
import { TID } from "@/lib/constants";

export default function QuizCard({ quiz, cardId, onAttempt, onSkip, onRequireAuth, isAuthed }) {
  const [selected, setSelected] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const correct = quiz.correct_index;

  const submit = () => {
    if (!isAuthed) {
      onRequireAuth && onRequireAuth();
      return;
    }
    if (selected === null) return;
    const isCorrect = selected === correct;
    setSubmitted(true);
    onAttempt && onAttempt({ card_id: cardId, selected_index: selected, is_correct: isCorrect });
  };

  return (
    <div className="w-full max-w-[720px] mx-auto" data-testid={TID.quizRoot} data-card-id={cardId}>
      <div className="rounded-2xl bg-[#1A2232] border border-[#26334D] p-5 sm:p-6 shadow-[0_10px_30px_rgba(15,23,42,0.06)]">
        <div className="text-xs font-semibold tracking-wide text-[#94A3B8] uppercase">Micro Active-Recall Quiz</div>
        <h3 className="mt-2 text-base font-semibold text-[#F8FAFC]">{quiz.question}</h3>
        <div className="mt-4 space-y-2">
          {quiz.options.map((opt, i) => {
            const isSel = selected === i;
            const isRight = submitted && i === correct;
            const isWrong = submitted && isSel && i !== correct;
            return (
              <button
                key={`${i}-${opt}`}
                type="button"
                onClick={() => !submitted && setSelected(i)}
                data-testid={TID.quizOption}
                data-option-index={i}
                className={`w-full text-left rounded-2xl border px-4 py-3 text-sm transition-colors ${
                  isRight ? "border-[#2F6F4F] bg-[#2F6F4F]/10 text-[#2F6F4F]" :
                  isWrong ? "border-[#B42318] bg-[#B42318]/10 text-[#B42318]" :
                  isSel ? "border-[#E85A2A] bg-[#E85A2A]/5 text-[#F8FAFC]" :
                  "border-[#26334D] bg-[#1A2232] text-[#F8FAFC] hover:bg-[#232E45]"
                }`}
              >{opt}</button>
            );
          })}
        </div>
        {submitted ? (
          <div className="mt-3 text-sm text-[#F8FAFC]" style={{ lineHeight: 1.6 }}>
            {selected === correct ? "✓ Correct." : "✗ Not quite."} {quiz.explanation}
          </div>
        ) : null}
        <div className="mt-5 flex items-center gap-2">
          {!submitted ? (
            <button
              type="button"
              onClick={submit}
              data-testid={TID.quizSubmit}
              disabled={selected === null}
              className="flex-1 rounded-xl bg-[#E85A2A] text-[#F8FAFC] py-3 text-sm font-semibold hover:bg-[#C94A1D] transition-colors disabled:opacity-40"
            >Submit</button>
          ) : (
            <button
              type="button"
              onClick={onSkip}
              className="flex-1 rounded-xl bg-[#E85A2A] text-[#F8FAFC] py-3 text-sm font-semibold hover:bg-[#C94A1D] transition-colors"
            >Continue</button>
          )}
          <button
            type="button"
            onClick={onSkip}
            className="rounded-xl border border-[#26334D] bg-[#1A2232] px-4 py-3 text-sm font-semibold text-[#F8FAFC] hover:bg-[#232E45] transition-colors"
          >Skip</button>
        </div>
      </div>
    </div>
  );
}
